<ng-container *ngIf="serviceWorkerRegistered">
    <app-install rte="gK"></app-install>
    <!--Disable pwa-module app auto update to avoid collapsing the app-versioning-module app auto update.-->
    <!--<app-auto-update rte="gL"></app-auto-update>-->
    <app-pwa-cache></app-pwa-cache>
</ng-container>
